import lazyInit from 'util/lazyInit';

import {
  StructuredTable,
  StructuredTableAdapter,
  StructuredTableKind,
  UnknownStructuredTableAdapter,
} from './StructuredTableConstants';

export const getStructuredTableAdapters: () => {
  [index in StructuredTableKind]: UnknownStructuredTableAdapter;
} = lazyInit(() => {
  const RunOutputSamplesTableAdapter =
    require('lab-automation/output-samples/RunOutputSamplesTableAdapter').default;
  const ResultsTableAdapter = require('notebook/integrations/results/ResultsTableAdapter').default;
  const MixtureIngredientsStructuredTableAdapter =
    require('notebook/integrations/registry/MixtureIngredientsStructuredTableAdapter').default;
  const MixtureMetadataStructuredTableAdapter =
    require('notebook/integrations/registry/MixtureMetadataStructuredTableAdapter').default;
  const {
    RegistrationStructuredTableAdapter,
  } = require('notebook/integrations/registry/RegistrationStructuredTableAdapter');
  const {
    BoxCreationStructuredTableAdapter,
  } = require('notebook/integrations/samples/BoxCreationStructuredTableAdapter');
  const {
    PlateCreationStructuredTableAdapter,
  } = require('notebook/integrations/samples/PlateCreationStructuredTableAdapter');
  const InventoryStructuredTableAdapter =
    require('notebook/integrations/samples/InventoryStructuredTableAdapter').default;
  const {
    TransferStructuredTableAdapter,
  } = require('notebook/integrations/samples/TransferStructuredTableAdapter');
  const ProcessOutputStructuredTableAdapter =
    require('processes/tables/ProcessOutputStructuredTableAdapter').default;
  const ProcessTaskStructuredTableAdapter =
    require('processes/tables/ProcessTaskStructuredTableAdapter').default;
  const LookupStructuredTableAdapter =
    require('notebook/integrations/lookup/LookupStructuredTableAdapter').default;
  const SummaryViewStructuredTableAdapter =
    require('samples/plate-maps/transfer-table/SummaryViewStructuredTableAdapter').default;
  const WellViewStructuredTableAdapter =
    require('samples/plate-maps/transfer-table/WellViewStructuredTableAdapter').default;
  const PlateRecordDetailStructuredTableAdapter =
    require('samples/plate-maps/transfer-table/PlateRecordDetailStructuredTableAdapter').default;
  const BulkAssemblyFragmentsStructuredTableAdapter =
    require('molbio/bulk-assembly/tables/BulkAssemblyFragmentsStructuredTableAdapter').default;
  const BulkAssemblyConstructsStructuredTableAdapter =
    require('molbio/bulk-assembly/tables/BulkAssemblyConstructsStructuredTableAdapter').default;
  const BulkAssemblyPrimersStructuredTableAdapter =
    require('molbio/bulk-assembly/tables/BulkAssemblyPrimersStructuredTableAdapter').default;
  const ProcedureMaterialInputsTableAdapter =
    require('procedures/tables/ProcedureMaterialInputsTableAdapter').default;
  const ProcedureMaterialOutputsTableAdapter =
    require('procedures/tables/ProcedureMaterialOutputsTableAdapter').default;
  const ProcedureDataParametersConfigTableAdapter =
    require('procedures/tables/ProcedureDataParametersConfigTableAdapter').default;
  const ProcedureEquipmentTableAdapter = require('procedures/tables/ProcedureEquipmentTableAdapter').default;
  const TestDefinitionsTableAdapter = require('procedures/tables/TestDefinitionsTableAdapter').default;
  const AppCanvasStructuredTableAdapter =
    require('benchling-apps/interactivity/ui-blocks/tables/AppCanvasStructuredTableAdapter').default;
  const ParameterStructuredTableAdapter =
    require('notebook/integrations/procedures/ParameterStructuredTableAdapter').default;
  return {
    [StructuredTableKind.MIXTURE_METADATA]: new MixtureMetadataStructuredTableAdapter(
      StructuredTableKind.MIXTURE_METADATA
    ),
    [StructuredTableKind.MIXTURE_INGREDIENTS]: new MixtureIngredientsStructuredTableAdapter(
      StructuredTableKind.MIXTURE_INGREDIENTS
    ),
    [StructuredTableKind.INVENTORY]: new InventoryStructuredTableAdapter(StructuredTableKind.INVENTORY),
    [StructuredTableKind.PLATE_CREATION]: new PlateCreationStructuredTableAdapter(
      StructuredTableKind.PLATE_CREATION
    ),
    [StructuredTableKind.BOX_CREATION]: new BoxCreationStructuredTableAdapter(
      StructuredTableKind.BOX_CREATION
    ),
    [StructuredTableKind.RUN_OUTPUT_SAMPLES]: new RunOutputSamplesTableAdapter(
      StructuredTableKind.RUN_OUTPUT_SAMPLES,
      {locked: true}
    ),
    [StructuredTableKind.REGISTRATION]: new RegistrationStructuredTableAdapter(
      StructuredTableKind.REGISTRATION
    ),
    [StructuredTableKind.RESULTS]: new ResultsTableAdapter(StructuredTableKind.RESULTS),
    [StructuredTableKind.TRANSFER]: new TransferStructuredTableAdapter(StructuredTableKind.TRANSFER),
    [StructuredTableKind.PROCESS_TASK]: new ProcessTaskStructuredTableAdapter(
      StructuredTableKind.PROCESS_TASK,
      {allowNoRowsInConfigs: true, allowMultipleRowsInConfigs: false, allowNoRowsInEntries: true}
    ),
    [StructuredTableKind.PROCESS_OUTPUT]: new ProcessOutputStructuredTableAdapter(
      StructuredTableKind.PROCESS_OUTPUT,
      {allowNoRowsInConfigs: true, allowMultipleRowsInConfigs: false}
    ),
    [StructuredTableKind.LOOKUP]: new LookupStructuredTableAdapter(StructuredTableKind.LOOKUP),
    [StructuredTableKind.FILL_PLATE_TRANSFER_SUMMARY_VIEW]: new SummaryViewStructuredTableAdapter(
      StructuredTableKind.FILL_PLATE_TRANSFER_SUMMARY_VIEW
    ),
    [StructuredTableKind.FILL_PLATE_TRANSFER_WELL_VIEW]: new WellViewStructuredTableAdapter(
      StructuredTableKind.FILL_PLATE_TRANSFER_WELL_VIEW
    ),
    [StructuredTableKind.FILL_PLATE_TRANSFER_PLATE_RECORD]: new PlateRecordDetailStructuredTableAdapter(
      StructuredTableKind.FILL_PLATE_TRANSFER_PLATE_RECORD
    ),
    [StructuredTableKind.BULK_ASSEMBLY_FRAGMENTS]: new BulkAssemblyFragmentsStructuredTableAdapter(
      StructuredTableKind.BULK_ASSEMBLY_FRAGMENTS
    ),
    [StructuredTableKind.BULK_ASSEMBLY_CONSTRUCTS]: new BulkAssemblyConstructsStructuredTableAdapter(
      StructuredTableKind.BULK_ASSEMBLY_CONSTRUCTS
    ),
    [StructuredTableKind.BULK_ASSEMBLY_PRIMERS]: new BulkAssemblyPrimersStructuredTableAdapter(
      StructuredTableKind.BULK_ASSEMBLY_PRIMERS
    ),
    [StructuredTableKind.PROCEDURE_MATERIAL_INPUTS]: new ProcedureMaterialInputsTableAdapter(),
    [StructuredTableKind.PROCEDURE_MATERIAL_OUTPUTS]: new ProcedureMaterialOutputsTableAdapter(
      StructuredTableKind.PROCEDURE_MATERIAL_OUTPUTS
    ),
    [StructuredTableKind.PROCEDURE_DATA_PARAMETERS_CONFIG]: new ProcedureDataParametersConfigTableAdapter(
      StructuredTableKind.PROCEDURE_DATA_PARAMETERS_CONFIG
    ),
    [StructuredTableKind.PROCEDURE_EQUIPMENT]: new ProcedureEquipmentTableAdapter(),
    [StructuredTableKind.TEST_DEFINITIONS]: new TestDefinitionsTableAdapter(),
    [StructuredTableKind.APP_CANVAS]: new AppCanvasStructuredTableAdapter(StructuredTableKind.APP_CANVAS),
    [StructuredTableKind.PARAMETER]: new ParameterStructuredTableAdapter(StructuredTableKind.PARAMETER),
  };
});

export function isKnownStructuredTableAdapter(kind: string): boolean {
  return Object.keys(getStructuredTableAdapters()).includes(kind);
}

export function getStructuredTableAdapterFromTable<TTableMetadata, TRowMetadata>(
  table: StructuredTable<TTableMetadata, TRowMetadata>
): StructuredTableAdapter<TTableMetadata, TRowMetadata> {
  return getStructuredTableAdapters()[table.kind] as StructuredTableAdapter<TTableMetadata, TRowMetadata>;
}
